import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TCreateInvoiceResponse } from "../createInvoice/createInvoice.schema";
import { TUpdateInvoiceRequest } from "./updateInvoice.schema";

/**
 * @description
 * Updates an existing Invoice for a company.
 * Sends PATCH request to la-forge route: PATCH /api/invoices/:invoiceID
 *
 * @param axios - injected axios instance from AbstractApiClient
 * @param invoiceID - invoice ID to update
 * @param params - typed invoice payload (partial updates allowed)
 * @returns updated invoice data
 */
export const updateInvoice =
  (axios: IAxiosInstance) =>
  async (
    invoiceID: string,
    params: TUpdateInvoiceRequest
  ): Promise<TCreateInvoiceResponse> => {
    const response = await axios.noRetry.patch(
      `/api/invoices/${invoiceID}`,
      params
    );
    const resData = response.data;

    if (resData?.success) {
      return resData.data;
    }

    throw new Error(resData?.error || "Error updating invoice");
  };
